import React, { useState, useEffect, Fragment } from "react";
import AdminDashboard from "../../AdminDashboard";
import { dict } from "../../../../dictionary";
import { default_url } from "../../../..";
import { isAuthenticated } from "../../../../auth";
import { downloadExportOrdersToDelivery, exportOrdersToDelivery } from "../../apiAdmin"
import { store } from 'react-notifications-component';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(2),
            width: '25ch'
        },
    },
}));

function ExportOrdersToDelivery() {
    const classes = useStyles();
    const [values, setValues] = useState({
        error: null,
        redirectToReferrer: false,
        formData: ""
    });
    const { user, token } = isAuthenticated();
    const [loading, setLoading] = useState(false);

    const { formData, redirectToReferrer, error } = values;

    useEffect(() => {
        setValues({ ...values, formData: new FormData() });
    }, []);

    const handleChange = name => event => {
        for (let i = 0; i < event.target.files.length; i++) {
            formData.set(`orders`, event.target.files[i]);
        }
    };


    const clickSubmit = (event) => {
        event.preventDefault();
        setLoading(true);
        exportOrdersToDelivery(formData, user._id, token)
            .then(data => {
                setLoading(false);
                if (data.error) {
                    setValues({ ...values, error: data.error, redirectToReferrer: false });
                } else {
                    downloadExportOrdersToDelivery(user._id, token).then(res2 => {
                        showSuccess();
                        setLoading(false);
                    })

                }
            })
    }

    const showError = () => {
        return (
            <div className="alert alert-danger" style={{ display: error ? "" : "none" }}>
                {error}
            </div>
        )
    }

    const showSuccess = () => {
        store.addNotification({
            message: dict['orders_have_been_exported'],
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
                duration: 2500,
                onScreen: true,
                showIcon: true
            }
        });
    }

    const arStyleRequiredStart = {
        left: "30px"
    }
    const enStyleRequiredStart = {
        right: "30px"
    }
    const arStylelabel = {
        float: "right"
    }
    const enStylelabel = {
        float: "left"
    }

    const multipleExport = () => {
        return (
            <div className="multipleCategoriesForm">
                <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["excel_file"]} <span className="redStar">*</span></label>
                <input onChange={handleChange("excel")} type="file" multiple className="inputField form-control" name="excel" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"></input>
            </div>
        )
    }

    const showBackdrop = () => {
        return (
            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }

    const form = () => {
        return (
            <div className="userProfileDataContainer">
                {showBackdrop()}
                {showError()}
                <h3 className="formContainerTitle">{dict["export_orders_to_delivery"]}</h3>
                <h6 className="requiredStar requiredStarUserDashbord" style={default_url == "/en/" ? enStyleRequiredStart : arStyleRequiredStart}>{dict["required"]}</h6>
                <form >
                    {multipleExport()}
                    <button onClick={clickSubmit} type="submit" className="dashboardBtn">{dict["export"]}</button>
                </form>
            </div>
        )
    }

    return (
        <AdminDashboard
            active="5"
            data={form}
        />
    )
}

export default ExportOrdersToDelivery;